
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user, profile, signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('로그아웃 실패:', error);
    }
  };

  const handleHomeClick = () => {
    navigate('/');
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* 로고 */}
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="https://static.readdy.ai/image/3dd345f1161c0117e4cc98032d537979/9e9b5041da0d1342cba62df04a945317.png" 
              alt="MUST Logo" 
              className="h-10 w-auto"
            />
            <span className="text-xl font-bold text-gray-900">MUST</span>
          </Link>

          {/* 데스크톱 메뉴 */}
          <div className="hidden md:flex items-center space-x-1">
            <button
              onClick={handleHomeClick}
              className="px-4 py-2 text-sm text-gray-700 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              홈으로
            </button>
            <Link
              to="/content"
              className="px-4 py-2 text-sm text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap"
            >
              콘텐츠
            </Link>
            <Link
              to="/commerce"
              className="px-4 py-2 text-sm text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap"
            >
              커머스
            </Link>
            <Link
              to="/community"
              className="px-4 py-2 text-sm text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap"
            >
              커뮤니티
            </Link>
            <Link
              to="/talent"
              className="px-4 py-2 text-sm text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap"
            >
              달란트
            </Link>
            <Link
              to="/events"
              className="px-4 py-2 text-sm text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap"
            >
              이벤트
            </Link>

            {user ? (
              <>
                <Link
                  to="/mypage"
                  className="px-4 py-2 text-sm text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap"
                >
                  마이페이지
                </Link>
                <button
                  onClick={handleSignOut}
                  className="px-4 py-2 text-sm text-gray-700 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
                >
                  로그아웃
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/auth/login"
                  className="px-4 py-2 text-sm text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap"
                >
                  로그인
                </Link>
                <Link
                  to="/auth/signup"
                  className="px-4 py-2 bg-teal-600 text-white text-sm rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap"
                >
                  회원가입
                </Link>
              </>
            )}
          </div>

          {/* 모바일 메뉴 버튼 */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>
      </div>

      {/* 모바일 메뉴 */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-2 space-y-1">
            <button
              onClick={() => {
                handleHomeClick();
                setIsMobileMenuOpen(false);
              }}
              className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              홈으로
            </button>
            <Link
              to="/content"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap"
            >
              콘텐츠
            </Link>
            <Link
              to="/commerce"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap"
            >
              커머스
            </Link>
            <Link
              to="/community"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap"
            >
              커뮤니티
            </Link>
            <Link
              to="/talent"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap"
            >
              달란트
            </Link>
            <Link
              to="/events"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap"
            >
              이벤트
            </Link>

            {user ? (
              <>
                <Link
                  to="/mypage"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap"
                >
                  마이페이지
                </Link>
                <button
                  onClick={() => {
                    handleSignOut();
                    setIsMobileMenuOpen(false);
                  }}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                >
                  로그아웃
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/auth/login"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap"
                >
                  로그인
                </Link>
                <Link
                  to="/auth/signup"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-4 py-2 bg-teal-600 text-white text-sm rounded-lg hover:bg-teal-700 transition-colors text-center whitespace-nowrap"
                >
                  회원가입
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
